(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perleni-bundle-picker"]) return;
  try {
    
  if (!customElements.get('perleni-bundle-picker')) {
    customElements.define('perleni-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.variants = JSON.parse(this.querySelector('[data-bundle-data]').textContent);
        this.choices = Array.from(this.querySelectorAll('[data-bundle-choice]'));
        this.variantInput = this.querySelector('[data-bundle-variant]');
        this.button = this.querySelector('[data-bundle-add]');
        this.count = this.querySelector('[data-bundle-count]');
        this.country = this.querySelector('[data-bundle-country]');
        this.querySelector('.perleni-bundle-picker__choices').hidden = false;
        this.button.hidden = false;
        this.addEventListener('change', () => this.update());
        this.querySelector('form').addEventListener('submit', event => {
          this.update();
          if (this.button.disabled) event.preventDefault();
        });
        this.update();
      }
      update() {
        const selected = this.choices.filter(choice => choice.checked);
        this.choices.forEach(choice => { choice.disabled = selected.length >= 3 && !choice.checked; });
        const sku = 'PERLENI-TRIO-' + selected.map(choice => choice.value).join('-');
        const variant = selected.length === 3 ? this.variants.find(item => item.sku === sku) : null;
        this.variantInput.value = variant?.id || '';
        this.variantInput.disabled = !variant?.available;
        this.button.disabled = !variant?.available;
        this.count.textContent = variant && !variant.available ? this.dataset.unavailable : this.dataset.countLabel.replace('[count]', String(selected.length));
        const destination = this.country.selectedOptions[0];
        this.querySelector('[data-bundle-shipping]').textContent = destination.dataset.shipping;
        this.querySelector('[data-bundle-total]').textContent = destination.dataset.total;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perleni-four-bundle-picker"]) return;
  try {
    
  if (!customElements.get('perleni-four-bundle-picker')) {
    customElements.define('perleni-four-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.variants = JSON.parse(this.querySelector('[data-bundle-data]').textContent);
        this.choices = Array.from(this.querySelectorAll('[data-bundle-choice]'));
        this.variantInput = this.querySelector('[data-bundle-variant]');
        this.button = this.querySelector('[data-bundle-add]');
        this.count = this.querySelector('[data-bundle-count]');
        this.country = this.querySelector('[data-bundle-country]');
        this.querySelector('.perleni-four-bundle-picker__choices').hidden = false;
        this.button.hidden = false;
        this.addEventListener('change', () => this.update());
        this.querySelector('form').addEventListener('submit', event => {
          this.update();
          if (this.button.disabled) event.preventDefault();
        });
        this.update();
      }
      update() {
        const selected = this.choices.filter(choice => choice.checked);
        this.choices.forEach(choice => { choice.disabled = selected.length >= 4 && !choice.checked; });
        const sku = 'PERLENI-QUARTETT-' + selected.map(choice => choice.value).join('-');
        const variant = selected.length === 4 ? this.variants.find(item => item.sku === sku) : null;
        this.variantInput.value = variant?.id || '';
        this.variantInput.disabled = !variant?.available;
        this.button.disabled = !variant?.available;
        this.count.textContent = variant && !variant.available ? this.dataset.unavailable : this.dataset.countLabel.replace('[count]', String(selected.length));
        const destination = this.country.selectedOptions[0];
        this.querySelector('[data-bundle-shipping]').textContent = destination.dataset.shipping;
        this.querySelector('[data-bundle-total]').textContent = destination.dataset.total;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perleni-mega-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('perleni-hero-slider')) {
  customElements.define('perleni-hero-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.visible = true;
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.querySelector('[data-hero-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-hero-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      this.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); } });
      this.visibilityHandler = () => this.schedule();
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.updatePause();
      this.schedule();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); document.removeEventListener('visibilitychange', this.visibilityHandler); }
    updatePause() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.pauseButton.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, number) => { slide.hidden = number !== this.index; });
      this.dots.forEach((dot, number) => { if (number === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), 3000);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perleni-six-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
 const dialog=document.querySelector('.perleni-choice');
 if(!dialog)return;
 const close=()=>dialog.close();
 dialog.querySelector('.perleni-six-close').addEventListener('click',close);
 dialog.querySelector('.perleni-six-later').addEventListener('click',close);
 dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
 let busy=false;
 const setButton=dialog.querySelector('[data-choice-set]'),setStatus=dialog.querySelector('[data-set-status]');
 setButton?.addEventListener('click',async()=>{
 if(busy)return;
 busy=true;setButton.disabled=true;setButton.setAttribute('aria-busy','true');setStatus.textContent=setStatus.dataset.loading;
 try{
 if(!window.PerleniMega?.addSet)throw new Error('Bitte lade die Seite erneut.');
 const cart=await window.PerleniMega.addSet(Number(setButton.dataset.choiceSet),['cart-icon-bubble']);
 const icon=document.getElementById('cart-icon-bubble'),html=cart.sections?.['cart-icon-bubble'];
 if(icon&&html){const fresh=new DOMParser().parseFromString(html,'text/html').querySelector('.shopify-section');if(fresh)icon.innerHTML=fresh.innerHTML;}
 close();const toast=document.querySelector('.perleni-choice-toast');toast.textContent=setStatus.dataset.success;toast.hidden=false;setTimeout(()=>toast.hidden=true,4500);
 if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'perleni-choice',cartData:cart});
 }catch(error){setStatus.textContent=error.message;}finally{busy=false;setButton.disabled=false;setButton.removeAttribute('aria-busy');}
 });
 let seen=false;try{seen=sessionStorage.getItem('perleni-choice-seen')==='1';}catch{}
 if(seen)return;
 setTimeout(()=>{if(document.querySelector('dialog[open],.perleni-popup.is-visible')||document.hidden)return;dialog.showModal();try{sessionStorage.setItem('perleni-choice-seen','1');}catch{}},2000);
})();

  } catch(e) { console.error(e); }
})();
})();
